import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@real-code-query/ui/Form'
import { Input } from '@real-code-query/ui/Input'
import { SubmitHandler, UseFormReturn } from 'react-hook-form'

import { TEmailAuthSignInForm } from '@/forms/types'

export const EMAIL_SIGN_IN_FORM_ID = 'email-sign-in-form'

interface IEmailSignInFormProps {
  form: UseFormReturn<TEmailAuthSignInForm>
  onSubmit: SubmitHandler<TEmailAuthSignInForm>
}

export const EmailSignInForm = ({ form, onSubmit }: IEmailSignInFormProps) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <Form {...(form as any)}>
      <form className="space-y-4" id={EMAIL_SIGN_IN_FORM_ID} onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          control={form.control as any}
          name="email"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input {...field} type="email" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          control={form.control as any}
          name="password"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormLabel>Password</FormLabel>
              <FormControl>
                <Input {...field} type="password" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  )
}
